<template>
	<div class="root">
		<TableBlock ref="tableData" :columns="cloumn" :action="action" :param="param" :navHeight="270">
			<div class="common-space-between">
				<div class="common-items-center">
					<InputBlock title="来源类型" :width="150">
					    <el-select v-model="param.source" placeholder="请选择来源类型" :size="this.$store.state.btnSize">
					        <el-option v-for="item in this.$store.state.conText.sourceList" :key="item.val" :label="item.title" :value="item.val" />
					    </el-select>
					</InputBlock>
					<el-input v-model="param.keyword" ref="keyWord" style="width:150px;margin-right: 10px;"
						:size="this.$store.state.btnSize" placeholder="请输入内容"></el-input>
					<Month title="操作日期" ref="mouth" @getDate="getDate"></Month>
					<el-button class="btn-heigth" type="primary" icon="el-icon-search" :size="this.$store.state.btnSize" @click="searchBtn">搜索</el-button>
					<el-button class="btn-heigth" type="danger" icon="el-icon-refresh" :size="this.$store.state.btnSize" @click="resetBtn">重置</el-button>					
				</div>
				<div>			
					<el-button type="primary" icon="el-icon-download" size="small" @click="exportBtn">导出</el-button>
				</div>
				</div>
		</TableBlock>
		<editBlock ref="add"></editBlock>
	</div>
</template>

<script>
	import {operate} from '@/utils/config'
	 import {exportFun} from '@/utils/httpFun'
	import {columns} from './index.js'
	import Month from '@/components/component-block/block-month.vue'
	import editBlock from './edit-block-undeal.vue'
	export default {
		components: {
			Month: Month,
			 editBlock:editBlock
		},
		data() {
			return {
				cloumn: [],
				action: operate.DEALWITHLIST,
				param: {
					endTime: "",
					startTime: "",
					keyword: "",
					processStatus:0,
					source:null
						
				},
				processStatus: 0 //1：已处理；0：未处理
			};
		},
		created() {
			this.cloumn = columns(this);
		},
		mounted() {

		},
		methods: {

			searchBtn() {
				this.$refs.tableData.getDatas()
			},
			resetBtn() {
				this.$refs.mouth.clear()
				this.$refs.tableData.resetHttp()
				this.$refs.keyWord.clear()
				this.param.startTime=null
				this.param.endTime=null
				this.param.source=null
			},
			//获取时间
			getDate(ev) {
				this.param.startTime=ev.startDate
				this.param.endTime=ev.endDate
			},
			//查看
			dealBtn(ev) {
				console.log(ev)
				this.$refs.add.showMessage("deal",ev);
			},
			//导出
			exportBtn(){
			      exportFun(operate.EXPORTSUGGSE,this.param,"意见待处理记录")

			}
		}
	}
</script>

<style lang="scss" scoped></style>